import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
// recoil
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
// ex-module
import Logout from "@components/login/Logout";
import DashBoardHeader from "@layout/header/dashBoard/DashBoardHeader";
import MyAccount from "@layout/header/dashBoard/MyAccount";
import { checkTypeState, curAdminTreeState, curConsultInfo, curMonitoringTreeState, curSchduleTreeState, mainState, noneUrl, } from "@recoil/assessmentState";
import { langState } from "@recoil/langState";
import { checkSheetState, loadingBoxState, menuListState, parentCode, urlState } from "@recoil/menuState";
import * as CONST from "@utils/Const";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
function ServiceLayout() {
    // 이동
    const location = useLocation();
    const navigate = useNavigate();
    const loading = useRecoilValue(loadingBoxState);
    // recoil
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    const resetCheckSheet = useResetRecoilState(checkSheetState);
    const resetRecoilTreeData = useResetRecoilState(curSchduleTreeState);
    const resetRecoilData = useResetRecoilState(curMonitoringTreeState);
    const resetRecoilAdminData = useResetRecoilState(curAdminTreeState);
    const resetConsultInfo = useResetRecoilState(curConsultInfo);
    const resetCheck = useResetRecoilState(checkTypeState);
    const resetRecoilState = useResetRecoilState(mainState);
    const recoilNoneUrlInfo = useRecoilValue(noneUrl);
    const menuRecoilList = useRecoilValue(menuListState);
    const langs = useRecoilValue(langState); // recoil langState
    const setMenuCodeRecoil = useSetRecoilState(parentCode);
    const [menuList, setMenuList] = useState(null);
    useEffect(() => {
        setRecoilUrlInfo(location.pathname);
    }, [location.pathname]);
    // 특정 화면에서 url로 menu 정보 추출하기 위함
    useEffect(() => {
        let tmenuList = menuRecoilList;
        if (tmenuList.length <= 0) {
        }
        let curMenu = null;
        tmenuList
            .filter((smenu) => smenu.url === urlInfo)
            .map((smenu) => {
            if (smenu.url === urlInfo)
                curMenu = smenu;
        });
        setMenuCodeRecoil(curMenu && curMenu.parentCode);
        const tempMenu = [];
        tmenuList
            .filter((smenu) => curMenu && smenu.parentCode === curMenu.parentCode)
            .map((smenu) => {
            tempMenu.push({
                menuName: smenu.menuName,
                menuUrl: smenu.url,
            });
        });
        setMenuList(tmenuList);
        if (!recoilNoneUrlInfo) {
            // 초기화
            resetCheckSheet();
            resetRecoilData(); //모니터링
            resetRecoilTreeData(); //오늘의 점검
            resetRecoilAdminData(); //운영관리
            resetConsultInfo();
            resetCheck(); // 진단점검
            resetRecoilState();
        }
        if (menuRecoilList != null && menuRecoilList.length != 0 && !menuRecoilList.some((menu) => menu.url === urlInfo)) {
            navigate(CONST.URL_NOT_FOUND, { replace: true });
        }
    }, [urlInfo, menuRecoilList]);
    useEffect(() => {
        const handleClick = (e) => {
            const targetElement = e.target;
            const isSelect = targetElement.classList.contains("select") || targetElement.closest(".select");
            if (isSelect) {
                return;
            }
            const allSelectBoxElements = document.querySelectorAll(".select");
            allSelectBoxElements.forEach((boxElement) => {
                boxElement.classList.remove("active");
            });
        };
        window.addEventListener("click", handleClick);
        return () => window.removeEventListener("click", handleClick);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ id: "wrap", className: `${langs == CONST.STR_LANG_ENG ? "lang-eng" : ""}` }, { children: [_jsx(DashBoardHeader, {}), menuList && urlInfo && _jsx(Outlet, {})] })), _jsx(Logout, { path: CONST.URL_LOGIN }), _jsx(MyAccount, {}), _jsx("div", { className: "dimm" }), loading && _jsx(Loading, {})] }));
}
export default ServiceLayout;
function Loading(props) {
    const loadingBox = useRecoilValue(loadingBoxState);
    const isAuth = props.isAuth;
    return (_jsx("div", Object.assign({ className: !isAuth || loadingBox ? "loading" : "" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB85C\uB529\uC911" })) })));
}
